<template>
  <div id="login">
    <v-card
      class="mx-auto"
      max-width="600"
      outlined
      raised
    >
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline mb-4">
            Welcome to Master Setting
          </div>

          <v-form
            ref="form"
            lazy-validation
          >
            <v-text-field
              v-model="username"
              :rules="nameRules"
              :disabled="progressing"
              label="Username"
              required
            />
            <v-text-field
              v-model="password"
              :type="'password'"
              :rules="passwordRules"
              :disabled="progressing"
              label="Password"
              required
              @keydown.enter="login"
            />
          </v-form>
        </v-list-item-content>
      </v-list-item>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="success"
          :loading="loading"
          :disabled="loading"
          @click="login"
        >
          Login
        </v-btn>
        <v-snackbar                    
          v-model="snackbar"
          :color="snackbarColor"
          :top="true"                                       
          dark                    
        >
          <v-icon
            color="white"
            class="mr-4"
          >
            mdi-bell-plus
          </v-icon>
          <div align="left">
            {{ errorMessages }}
          </div>
          <v-icon
            size="16"
            @click="snackbar = false"
          >
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style scoped>
    #login {
        width: 500px;
        /* border: 1px solid #CCCCCC; */
        margin: auto;
        margin-top: 200px;
        padding: 20px;
    }
</style>

<script>
  export default {
    data: () => ({
      username: '',
      loading: false,
      password: '',
      progressing: false,
      snackbar: false,
      snackbarColor: 'error',
      errorMessages: 'Please try again',
      nameRules: [
        v => !!v || '*This field is required',
      ],
      passwordRules: [
        v => !!v || '*This field is required',
      ],
    }),
    methods: {
      setProgressing (value = false) {
        this.progressing = value
      },
      login () {
        if (this.$refs.form.validate()) {
          this.loading = true
          const username = this.username
          const password = this.password
          this.$store.dispatch('login', { username, password })
            .then((response) => {
              this.loadData()
                .then(data => {              
                  this.$router.push({ path: '/home' })   
                })
                .catch(() => {
                  this.$manualLogout()
                })
                .then(() => {
                  this.setProgressing(false)   
                })
            }).catch(err => {
              const response = err.response

              if ((response.data || {}).message) {
                this.errorMessages = (response.data || {}).message
              } 
              this.loading = false
              this.snackbar = true 
              this.setProgressing(false) 
            })
        }
      },
      loadData () {
        return this.$http.all([
          this.$store.dispatch('getUserPermissions'),
        ])
      },
    },
  }
</script>
